import {Button} from '@components/ui/button'
import {useTranslation} from '@/translations/i18n.tsx'
import {useState} from 'react'
import {Assignment} from '@features/assignment/types.ts'
import {SubmitToAirbnbModal} from '@features/assignment/components/submit-to-airbnb-modal'
import {VideoUploadModalRoot} from '@features/video-upload/components/video-upload-modal-root'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {AssignmentUploadVideoDropdown} from '@features/assignment/components/assignment-upload-video-dropdown'

export const AssignmentVideoButtons = ({assignment}: {assignment: Assignment}) => {
    const {t} = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const [isSubmitToAirbnbModalOpen, setIsSubmitToAirbnbModalOpen] = useState(false)
    const isVideoUploadModalOpen = useVideoUpload(store => store.isOpen)
    const [isDarylButtonClicked, setIsDarylButtonClicked] = useState(false)

    return (
        <div className="flex w-full flex-col items-center gap-2 md:w-auto md:flex-row [&>button]:w-full md:[&>button]:w-auto">
            <AssignmentUploadVideoDropdown
                assignment={assignment}
                setIsLoading={setIsLoading}
                setClickedDarylButton={() => setIsDarylButtonClicked(true)}
            />

            <Button
                variant="primary"
                onClick={() => setIsSubmitToAirbnbModalOpen(true)}
                disabled={!isDarylButtonClicked || !assignment.can_send_to_airbnb || isLoading}
            >
                {t('single_shooting:submit_to_airbnb')}
            </Button>

            {isVideoUploadModalOpen && <VideoUploadModalRoot />}

            {isSubmitToAirbnbModalOpen && (
                <SubmitToAirbnbModal
                    onClose={() => setIsSubmitToAirbnbModalOpen(false)}
                    assignment={assignment}
                    setSuccessModalCb={() => setIsSubmitToAirbnbModalOpen(false)}
                />
            )}
        </div>
    )
}
